import React, { FC } from "react";
import { Icon } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { IconTypesKeys } from "@evergis/ui/dist/atoms/Icon/Icon";

import { StructureControl } from "../styled";

import { AccessControlProps } from "../types";

export const AccessControl: FC<AccessControlProps> = ({
  type,
  active,
  onClick,
  disabled,
  partial,
  clickable = true,
}) => {
  const { t } = useTranslation("dialogs");

  return (
    <StructureControl
      disabled={disabled}
      active={active}
      onClick={onClick}
      title={t(`access.${type}Hint`)}
      partial={partial}
      clickable={clickable}
    >
      <Icon kind={`set_${type === "write" ? "edit" : type}` as IconTypesKeys} />
    </StructureControl>
  );
};
